import styles from "./styles.module.scss";
import React, { useEffect } from "react";
import useCollapse from "react-collapsed";
import { Link } from "react-router-dom";

function Collapsible() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>Transformation digitale : nos domaines d’intervention</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    Alliant expertise métier et polyvalence, nos équipes vous accompagnent tout au long du processus de votre transformation digitale en
                    vous fournissant du conseil et de l’assistance de qualité et sur mesure.<br />
                    Elles s’associent à vous dans vos projets de :
                    <p>Développement de l’orientation « Client » de la fonction SI</p>
                    <p>Accompagnement au déploiement d’outils collaboratifs</p>
                    <p>Digitalisation des processus métiers</p>
                    <p>Diffusion et communication transverse</p>
                    <p>Réactivité face aux changements</p>
                    <p>Sécurité des données</p>
                    <p>Appréhension des nouveaux outils pour les mettre au service de l’entreprise</p>
                    <p>Transformation des métiers, conduite du changement et adaptation et gestion des compétences</p>
                </div>
            </div>
        </div>
    );
}
function Collapsible2() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>Transformation digitale : notre méthodologie</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    Associant rigueur et flexibilité, notre méthodologie est conçue de façon à vous apporter savoir-faire et guidance à toutes
                    les étapes de votre parcours de digitalisation.
                    <br /><br />
                    Notre méthodologie se décline en 5 phases :
                    <p>Audit et diagnostic de l’existant </p>
                    <p>Identification des potentialités et axes de transformation digitale pertinents</p>
                    <p>Elaboration d’un plan d’action opérationnel</p>
                    <p>Mise en œuvre et pilotage du processus de transformation digitale et humaine</p>
                    <p>Suivi et ancrage du changement</p>
                </div>
            </div>
        </div>
    );
}

function Intro() {
    useEffect(() => {
        window.scrollTo(0, 1000)
    }, [])

    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>
                    <text>Transformation digitale</text>
                    <p>pour la réussite de vos projets</p>
                </div>
                <div className={styles.bigbox}>

                    <div className={styles.service}>
                        <div className={styles.bigText}>Conseil et stratégie en transformation digitale</div>
                        <div className={styles.paragraph}>
                            En plein essor, l’économie numérique place désormais le digital au centre de l’évolution des métiers et des s
                            ecteurs d’activité. La digitalisation a transformé les habitudes et préférences des clients, révolutionné la chaîne de valeur 
                            des organisations et influencé les modes de gestion existants. 
                            <br/><br/>
                            Face à cette évolution, nombreuses sont les organisations qui engagent une réflexion sur les meilleures façons d’assurer leur transformation digitale de manière à répondre aux attentes renouvelées de leurs parties prenantes internes et externes et renforcer leur compétitivité dans un environnement numérique en constante évolution.
                            <br/><br/>
                            Experts en transformation digitale et en management humain et organisationnel, nos collaborateurs accompagnent les organisations qui s
                            ouhaitent assurer leur transition digitale, à l’intégration des technologies numériques et l’instauration d’une culture digitale qui place l’humain
                            au centre de ses priorités.
                        </div>
                    </div>


                    <div className={styles.expandable}>
                        <Collapsible />
                        <Collapsible2 />
                    </div>

                </div>
                <div className={styles.title}>
                    <div className={styles.text2}>Autre services</div>
                </div>
                <div className={styles.bigbox2}>
                    <Link to="/services/developpementMobile">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>Développement Mobile</div>
                            <img src="/icons/smartphone.png" alt="web dev" />
                        </div>
                    </Link>
                    <Link to="/services/developpementWeb">
                    <div className={styles.service1}>
                        <div className={styles.bigText}>Développement Web</div>
                        <img src="/icons/desktop.png" alt="web dev" />
                    </div>
                    </Link>
                    <Link to="/services/e_commerce">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>E-COMMERCE ET MARKETPLACES</div>
                            <img src="/icons/e-commerce.png" alt="web dev" />

                        </div>
                    </Link>              
                    <Link to="/services/erp">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>INTÉGRATION ERP</div>
                            <img src="/icons/integration.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/seo">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>SEO ET OPTIMISATION</div>
                            <img src="/icons/seo.png" alt="web dev" />
                        </div>
                    </Link>
                </div>
            </section>
        </>
    )
}

export default Intro;